import { render } from "./Description.vue?vue&type=template&id=0493a899&scoped=true&ts=true"
import script from "./Description.vue?vue&type=script&lang=ts"
export * from "./Description.vue?vue&type=script&lang=ts"

import "./Description.vue?vue&type=style&index=0&id=0493a899&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0493a899"]])

export default __exports__